import { useState } from "react";
import { Progress } from "../../../../components/ui/progress";
import { Step1 } from "./Step1";
import { ShovellerSignupProvider } from "../../../../context/shovllerSignupFormContext";
import { Step2 } from "./Step2";
import { Step3 } from "./Step3";
import { Step4 } from "./Step4";
import { Step5 } from "./Step5";

export function SignupWizard() {
  const steps = [Step1, Step2, Step3, Step4, Step5];
  const totalSteps = steps.length;

  const [step, setStep] = useState(0);

  const goToStep = (newStep) => {
    setStep(newStep);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const nextStep = () => {
    if (step < totalSteps - 1) goToStep(step + 1);
  };

  const preStep = () => {
    if (step > 0) goToStep(step - 1);
  };

  const progress = ((step + 1) / totalSteps) * 100;
  const CurrentStep = steps[step];

  return (
    <ShovellerSignupProvider>
      <div className="flex flex-col w-full">
        {/* Progress Header */}
        <div className="w-full border-b md:border-none bg-white md:bg-transparent">
          <div className="max-w-3xl mx-auto py-6 px-6">
            <div className="space-y-3">
              <div className="flex justify-between text-gray-700 text-lg">
                <span>
                  Step {step + 1} of {totalSteps}
                </span>
                <span className="font-semibold">{Math.round(progress)}% Complete</span>
              </div>
              <Progress value={progress} className="h-2 w-full" />
            </div>
          </div>
        </div>

        {/* Step Content */}
        <div className="flex-1 max-w-2xl mx-auto w-full">
          <CurrentStep currentStep={step} totalSteps={totalSteps} nextStep={nextStep} preStep={preStep} />
        </div>
      </div>
    </ShovellerSignupProvider>
  );
}
